import { useAtomValue } from 'jotai';

import ZoomableViwer from '../../../../@common/ZoomableViewer';
import DesktopPageNavigationButton from '../../../../@common/PageNavigationButton/Desktop';
import DesktopFreeBadge from '../../../../@common/FreeBadge/Desktop';
import DesktopIntro from '../../../../@common/Intro/Desktop';
import { MessageBoxItemType, PdfViewerRedirect } from '../../../index.types';
import DesktopPageWrapper from '../../../../@common/PageWrapper/Desktop';
import DesktopPage from '../../../../@common/Viewer/Desktop';
import DesktopAnnotationLayer from '../../../../@common/Layer/OneOnOneAnnotationLayer/Desktop';
import { thumbnailsAtom } from '../../index.atom';
import DesktopViewerLayer from '../../../../@common/Layer/DefaultViewerLayer/Desktop';

interface Props {
  data: PdfViewerRedirect;
  domain?: string;
  messageBoxItems?: MessageBoxItemType[];
  translateKoToEn: (item: string) => string;
  updateNextThumbnails: (page: number) => void;
  updatePrevThumbnails: (page: number) => void;
  isBulk: boolean;
}

const Desktop = ({
  data,
  domain,
  messageBoxItems,
  translateKoToEn,
  updateNextThumbnails,
  updatePrevThumbnails,
  isBulk = false,
}: Props) => {
  const thumbnails = useAtomValue(thumbnailsAtom);

  const { isDownloadEnabled, name, thumnail, pages, userSubscriptionPlan } =
    data;

  return (
    <>
      <DesktopIntro translateKoToEn={translateKoToEn} />

      <DesktopPageWrapper totalPage={data.pages}>
        <DesktopViewerLayer
          translateKoToEn={translateKoToEn}
          fileName={name}
          domain={domain}
          isBulk={isBulk}
          isDownloadEnabled={isDownloadEnabled}
        />

        <ZoomableViwer>
          <DesktopPage
            thumnails={thumbnails?.map((value) => {
              if (value?.thumnail) {
                return {
                  src: value.thumnail,
                  imageSources: value.imageSources,
                };
              }
              return null;
            })}
          />

          {thumnail && (
            <DesktopAnnotationLayer
              thumnail={thumnail}
              messageBoxItems={messageBoxItems}
            />
          )}
        </ZoomableViwer>

        <DesktopPageNavigationButton
          totalPage={Number(pages)}
          updatePrevThumbnails={updatePrevThumbnails}
          updateNextThumbnails={updateNextThumbnails}
          isMoveCtaFormPageRequirements={true}
        />

        <DesktopFreeBadge userSubscriptionPlan={userSubscriptionPlan} />
      </DesktopPageWrapper>
    </>
  );
};

export default Desktop;
